import api from './api'

// Get all tasks with pagination and filters
export const getAllTasks = async (params = {}) => {
  try {
    const response = await api.get('/tasks', { params })
    return response.data
  } catch (error) {
    console.error('Error fetching tasks:', error)
    throw error
  }
}

// Get task by ID
export const getTaskById = async (id) => {
  try {
    const response = await api.get(`/tasks/${id}`)
    return response.data
  } catch (error) {
    console.error('Error fetching task:', error)
    throw error
  }
}

// Get tasks by project
export const getTasksByProject = async (projectId) => {
  try {
    const response = await api.get(`/tasks/project/${projectId}`)
    return response.data
  } catch (error) {
    console.error('Error fetching project tasks:', error)
    throw error
  }
}

// Create new task
export const createTask = async (taskData) => {
  try {
    const response = await api.post('/tasks', taskData)
    return response.data
  } catch (error) {
    console.error('Error creating task:', error)
    throw error
  }
}

// Update task
export const updateTask = async (id, taskData) => {
  try {
    const response = await api.put(`/tasks/${id}`, taskData)
    return response.data
  } catch (error) {
    console.error('Error updating task:', error)
    throw error
  }
}

// Delete task
export const deleteTask = async (id) => {
  try {
    const response = await api.delete(`/tasks/${id}`)
    return response.data
  } catch (error) {
    console.error('Error deleting task:', error)
    throw error
  }
}

// Get task statistics
export const getTaskStats = async (params = {}) => {
  try {
    const response = await api.get('/tasks/stats', { params })
    return response.data
  } catch (error) {
    console.error('Error fetching task stats:', error)
    throw error
  }
}

const taskService = {
  getAllTasks,
  getTaskById,
  getTasksByProject,
  createTask,
  updateTask,
  deleteTask,
  getTaskStats
}

export default taskService

